import {
  Box,
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SvgIcon,
  Toolbar,
  Typography,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { MENU_LIST } from "@/constants/layout";
import { MenuDto } from "@/dto/MenuDto";
import useMenu from "./useMenu";

export const Menu = () => {
  const { handleMenuClick, selected, expandedMenus, toggleExpanded } =
    useMenu();

  const renderMenuItem = (menu: MenuDto, index: number, isSubMenu = false) => {
    const hasChildren = menu.children && menu.children.length > 0;
    const isExpanded = expandedMenus[menu.title];
    const isSelected = menu.path ? selected(menu.path) : false;

    return (
      <Box key={index}>
        <ListItem
          disablePadding
          onClick={() =>
            hasChildren ? toggleExpanded(menu.title) : handleMenuClick(menu)
          }
          sx={{
            mb: isSubMenu ? 0.5 : 1,
            pl: isSubMenu ? 2 : 0,
          }}
        >
          <ListItemButton
            selected={isSelected}
            sx={{
              borderRadius: 1,
              "&.Mui-selected": {
                backgroundColor: "primary.main",
                color: "white",
                "&:hover": {
                  backgroundColor: "primary.dark",
                },
              },
            }}
          >
            {menu.icon && (
              <ListItemIcon>
                <SvgIcon
                  component={menu.icon}
                  color={isSelected ? "inherit" : "inherit"}
                  sx={{
                    color: isSelected ? "white" : "inherit",
                  }}
                />
              </ListItemIcon>
            )}
            <ListItemText
              primary={menu.title}
              sx={{
                color: isSelected ? "white" : "inherit",
              }}
            />
            {hasChildren && (isExpanded ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        </ListItem>

        {hasChildren && (
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {menu.children!.map((childMenu, childIndex) =>
                renderMenuItem(childMenu, childIndex, true)
              )}
            </List>
          </Collapse>
        )}
      </Box>
    );
  };

  return (
    <>
      <Toolbar
        sx={{
          display: "flex",
          direction: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "start",
            gap: 1,
          }}
        >
          <Typography variant="h6" fontWeight={"bold"} color={"primary"}>
            STEP AI
          </Typography>
          <Typography variant="caption" color={"primary"}>
            슈퍼 관리자
          </Typography>
        </Box>
      </Toolbar>
      <List sx={{ px: 1 }}>
        {MENU_LIST.map((menu: MenuDto, index: number) =>
          renderMenuItem(menu, index)
        )}
      </List>
    </>
  );
};
